import React from 'react'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
import { Wrapper } from './style'

const keywordCount = () => {
  return (
    <Wrapper>
        <AccordionWithArrow title='Keyword Count' expanded={true} accordionstyle='fieldset'>
          <Grid />
        </AccordionWithArrow>
    </Wrapper>
  )
}

export default keywordCount
